import type { FC } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SearchResultCategoryFilterFragmentFragmentDoc } from '@packages/gql/generated/shopping/SearchResultCategoryFilterFragmentFragmentDoc';
import { CategoryFilterStandalone } from '../CategoryFilterStandalone';
import { useSearchResultDataForCategoryFilter } from './useSearchResultDataForCategoryFilter';

/* GraphQL */ `
  fragment SearchResultCategoryFilterFragment on SuccessfulSearchResult {
    ...UseSearchResultDataForCategoryFilterFragment
  }
`;

export type SearchResultCategoryFilterProps = {
  maskedData: FragmentType<typeof SearchResultCategoryFilterFragmentFragmentDoc>;
  /** If `true`, shows a dedicated "clear all" interaction/button in addition to the root level category */
  showClearAll?: boolean;
  /** Callback fired when a category is clicked or all categories are cleared */
  onNavigate?: () => void;
};

/**
 * Formats SERP category navigation items to be used in CategoryFilterStandalone component
 * */
export const SearchResultCategoryFilter: FC<SearchResultCategoryFilterProps> = ({
  maskedData,
  showClearAll,
  onNavigate,
}) => {
  const data = getFragmentData(SearchResultCategoryFilterFragmentFragmentDoc, maskedData);

  const items = useSearchResultDataForCategoryFilter(data);

  return (
    <CategoryFilterStandalone
      categories={items}
      showClearAll={showClearAll}
      onNavigate={onNavigate}
    />
  );
};
